'use client';

import { useSyncExternalStore } from 'react';
import {
  getBetaAccessSnapshot,
  subscribeBetaAccess,
} from '@/components/early-access-gate/early-access-storage';

/**
 * Reactive read of the redeemed early-access grant (localStorage
 * `morfi_beta_access`, written only after a server-validated code). The server
 * snapshot is `false` so SSR always renders the locked-visitor state; the
 * change-event subscription flips consumers live when a grant lands in this
 * tab (e.g. a `?access=` email-link claim) or another one.
 */
export function useBetaAccess(): boolean {
  return useSyncExternalStore(subscribeBetaAccess, getBetaAccessSnapshot, (): boolean => false);
}
